import _objectSpread from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.sort.js";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import { iconColor } from "@/consts/iconColor";
var __default__ = {
  name: "LatestAbsenceInfo",
  components: {
    RowItem: RowItem
  },
  filters: {
    trim: function trim(value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    },
    mmdd: function mmdd(value) {
      if (!value) return "";
      value = value.toString();
      return value.slice(5);
    }
  },
  props: {
    attendances: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      attendancesMod: []
    };
  },
  computed: _objectSpread({}, mapState(["me"])),
  watch: {
    attendances: {
      immediate: true,
      handler: function handler() {
        var attendance = [];
        this.attendances.forEach(function (v) {
          var historyStudentArray = attendance.find(function (v2) {
            return v2[0].student_id === v.student_id && v2[0].date === v.date;
          });

          if (historyStudentArray) {
            historyStudentArray.push(v);
          } else {
            attendance.push([v]);
          }
        });
        this.attendancesMod = attendance.flatMap(function (v) {
          return v.sort(function (a, b) {
            return a.date > b.date ? 1 : -1;
          });
        });
      }
    }
  },
  methods: {
    iconColor: iconColor
  }
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // import { inject } from "vue";
    // const attendanceMode = inject("attendanceMode");
    // const changeAttendanceMode = () => {
    //   attendanceMode.value = "counter";
    // };
    return {
      __sfc: true,
      RowItem: RowItem,
      iconColor: iconColor
    };
  }
});